"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _constants = require("./constants");

var getActivitiesCategoryType = function getActivitiesCategoryType(types) {
  if (!(types === null || types === void 0 ? void 0 : types.length)) {
    return null;
  }

  var _loop = function _loop() {
    var _Object$entries$_i = (0, _slicedToArray2["default"])(_Object$entries[_i], 2),
        category = _Object$entries$_i[0],
        activities = _Object$entries$_i[1];

    if (types.every(function (type) {
      return activities.includes(type);
    })) {
      return {
        v: category
      };
    }
  };

  for (var _i = 0, _Object$entries = Object.entries(_constants.ACTIVITIES_BY_CATEGORIES); _i < _Object$entries.length; _i++) {
    var _ret = _loop();

    if ((0, _typeof2["default"])(_ret) === "object") return _ret.v;
  }

  return null;
};

var _default = getActivitiesCategoryType;
exports["default"] = _default;
//# sourceMappingURL=getActivitiesCategoryType.js.map